const stringToObject = (properties) => (str) =>
	properties.reduce(
		(res, k) => Object.assign(res, { [k.toLowerCase()]: str }),
		{},
	)

export { stringToObject as default }
